import { createSingleEntityStore } from '@core/ngrx-legacy';

import type { OpenQuestionsAssignedOffersList } from '../types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<OpenQuestionsAssignedOffersList>()(
    'OpenQuestionsTemplatesAssignedOffers',
    {
      customActions: adapter => ({
        fetch: (
          state,
          payload: { id: number; searchParams: { q: string | null; page: number; limit: number } },
        ) => adapter.markAsPending(state),
      }),
    },
  );

export {
  actions as OpenQuestionsTemplatesAssignedOffersActions,
  selectors as OpenQuestionsTemplatesAssignedOffersSelectors,
  reducer as OpenQuestionsTemplatesAssignedOffersReducer,
  namespace as OpenQuestionsTemplatesAssignedOffersNamespace,
};
